// extracted by mini-css-extract-plugin
export default {"flushModal":"modal_body_flushModal__zRNO6"};